import { render, staticRenderFns } from "./TopicSelector.vue?vue&type=template&id=d74ebde2&"
import script from "./TopicSelector.vue?vue&type=script&lang=js&"
export * from "./TopicSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports